import { Card, Badge, Button, DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from '@/components/ui';
import { EventTypeEnum } from '@/enums';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { MoreHorizontal, Eye, Trash2, Calendar, Users } from 'lucide-react';
import { getPhotoUrl, cn } from '@/lib/utils';
import { EVENT_STATUS_CONFIG } from '@/constants';
import type { IEvent } from '@/interfaces';
import EventPrice from './EventPrice';

type TProps = {
	event: IEvent;
	onDelete: (event: IEvent) => void;
	onViewDetails: (event: IEvent) => void;
	canDelete: boolean;
};

const getTypeBadge = (type: EventTypeEnum) => {
	const labels: Record<EventTypeEnum, string> = {
		[EventTypeEnum.BLIND_DATING]: 'Blind Dating',
	};
	return <Badge variant="outline">{labels[type]}</Badge>;
};

const DataTableMobileCard = ({ event, onDelete, onViewDetails, canDelete }: TProps) => {
	return (
		<Card className="p-4 space-y-3">
			<div className="flex gap-3">
				<img src={getPhotoUrl(event.bannerImage)} alt={event.title.fr} className="h-24 w-36 object-cover rounded shrink-0" />
				<div className="flex-1 min-w-0 flex flex-col justify-between">
					<div>
						<h3 className="font-medium text-sm line-clamp-2">{event.title.fr}</h3>
						<p className="text-xs text-muted-foreground line-clamp-1 mt-0.5">{event.description.fr}</p>
					</div>
					<div className="flex gap-2 flex-wrap mt-2">
						{getTypeBadge(event.type)}
						<Badge className={cn('text-xs font-medium', EVENT_STATUS_CONFIG[event.status].className)}>
							{EVENT_STATUS_CONFIG[event.status].label}
						</Badge>
					</div>
				</div>
				<DropdownMenu>
					<DropdownMenuTrigger asChild>
						<Button variant="ghost" size="sm" className="h-8 w-8 p-0 shrink-0 cursor-pointer">
							<MoreHorizontal className="h-4 w-4" />
						</Button>
					</DropdownMenuTrigger>
					<DropdownMenuContent align="end">
						<DropdownMenuItem className="cursor-pointer" onClick={() => onViewDetails(event)}>
							<Eye className="mr-2 h-4 w-4" />
							Voir détails
						</DropdownMenuItem>
						{canDelete && (
							<>
								<DropdownMenuSeparator />
								<DropdownMenuItem className="text-destructive cursor-pointer" onClick={() => onDelete(event)}>
									<Trash2 className="mr-2 h-4 w-4" />
									Supprimer
								</DropdownMenuItem>
							</>
						)}
					</DropdownMenuContent>
				</DropdownMenu>
			</div>
			<div className="flex items-center justify-between text-xs text-muted-foreground pt-1 border-t">
				<div className="flex items-center gap-1">
					<Calendar className="h-3.5 w-3.5" />
					<span>{format(new Date(event.startsAt), 'dd MMM yyyy', { locale: fr })}</span>
				</div>
				<EventPrice price={event.price} className="text-xs" />
				<div className="flex items-center gap-1 font-medium">
					<Users className="h-3.5 w-3.5" />
					<span>
						{event.metrics.registeredCount}
						{event.maxParticipants ? ` / ${event.maxParticipants}` : ''} inscrits
					</span>
				</div>
			</div>
		</Card>
	);
};

export default DataTableMobileCard;
